export const subscriptions = (() => {
    const subscriptionsCheckboxes = document.querySelectorAll(".subscriptions-toggle");

    Array.from(subscriptionsCheckboxes).forEach((cb) => addEL(cb));

    let requestPending = false;

    function addEL(cb) {
        if (!cb.hasAttribute("data-newsletterId")) return;

        cb.addEventListener("click", function (e) {
            if (requestPending) {
                e.preventDefault();
            }
        });

        cb.addEventListener("change", function () {

            if (!requestPending) {
                requestPending = true;

                const id = cb.getAttribute("data-newsletterId");
                const isChecked = cb.checked;
                const newsletterContactId = cb.getAttribute("data-newsletterContactId");
                const url = `/Newsletter/ToggleProperty/?propertyID=${id}&IsActive=${isChecked}&contactId=${newsletterContactId}`;
                cb.setAttribute("disabled", "disabled");


                fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({}),
                })
                    .then((response) => response.json())
                    .then((data) => {
                        console.log(data);
                        const success = data.success;
                        const isActive = data.isActive;
                        setStatus(cb, success, isActive, isChecked);
                        requestPending = false;
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                        setStatus(cb, false, false, isChecked);
                        requestPending = false;
                    });
            }

        });
    }

    function setStatus(cb, success, state, wasChecked) {
        if (success) {
            cb.removeAttribute("disabled");
            cb.checked = state;
            cb.previousElementSibling.classList.add("subscriptions-textLabel-updated");

            setTimeout(() => {
                cb.previousElementSibling.classList.remove("subscriptions-textLabel-updated");
            }, "1000");
        } else {
            cb.removeAttribute("disabled");
            cb.checked = !wasChecked;
        }
    }
})();
